import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
export default class AvailabilityID {
    constructor(public readonly value: number) {
        ensureNoUndefinedProperties(this)
    }
}
